import { useRouteError } from "react-router"
import { isChunkLoadError } from "../../../js/error"
import { ChunkError } from "./ChunkError"
import { DefaultError } from "./DefaultError"

export function ErrorTemplate() {
  const error = useRouteError() as { status?: number; message?: string } | null
  const isChunkError = isChunkLoadError(error)

  if (isChunkError) {
    return <ChunkError />
  }

  return <DefaultError error={error} />
}
